var map = {
	"./modalCovilha.template.tsx": 531,
	"./modalDetalhada.template.tsx": 335,
	"./modalExpo.template.tsx": 337,
	"./modalGaleria.template.tsx": 339,
	"./modalLink.template.tsx": 341,
	"./modalTexto.template.tsx": 343,
	"./modalVideo.template.tsx": 345,
	"./modalVideoGaleria.template.tsx": 347,
	"./modalViewer3d.template.tsx": 529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 333;